/**
 * Event system for GameCore
 * Allows Game.js to react to gameplay events without tight coupling
 */

export class GameCoreEvents {
    constructor() {
        this.listeners = {};
    }
    
    /**
     * Register an event listener
     * @param {string} eventName - Event name
     * @param {Function} callback - Callback function
     */
    on(eventName, callback) {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(callback);
    }
    
    /**
     * Emit an event
     * @param {string} eventName - Event name
     * @param {*} data - Event data
     */
    emit(eventName, data) {
        if (this.listeners[eventName]) {
            for (const callback of this.listeners[eventName]) {
                try {
                    callback(data);
                } catch (error) {
                    console.error(`Error in event listener for ${eventName}:`, error);
                }
            }
        }
    }
    
    /**
     * Remove an event listener
     * @param {string} eventName - Event name
     * @param {Function} callback - Callback function to remove
     */
    off(eventName, callback) {
        if (this.listeners[eventName]) {
            this.listeners[eventName] = this.listeners[eventName]
                .filter(cb => cb !== callback);
        }
    }
    
    /**
     * Remove all listeners for an event
     * @param {string} eventName - Event name (optional, removes all if not provided)
     */
    removeAllListeners(eventName) {
        if (eventName) {
            delete this.listeners[eventName];
        } else {
            this.listeners = {};
        }
    }
}

/**
 * Event type constants
 */
export const GameEvents = {
    // Asteroid events
    ASTEROID_SPAWNED: 'asteroid_spawned',
    ASTEROID_DAMAGED: 'asteroid_damaged',
    ASTEROID_DESTROYED: 'asteroid_destroyed',
    
    // Ship events
    SHIP_DAMAGED: 'ship_damaged',
    SHIP_HEALTH_CHANGED: 'ship_health_changed',
    
    // Bullet events
    BULLET_FIRED: 'bullet_fired',
    BULLET_DESTROYED: 'bullet_destroyed',
    
    // Collectible events
    COLLECTIBLE_SPAWNED: 'collectible_spawned',
    COLLECTIBLE_COLLECTED: 'collectible_collected',
    
    // Game state events
    GAME_OVER: 'game_over',
    SCORE_CHANGED: 'score_changed',
    ORE_CHANGED: 'ore_changed'
};



